// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"952e5eb7","359":"230cada8","529":"4cb407a4"}[chunkId] + ".chunk.js";
};